export default function ProfileSkeleton() {
  return (
    <div className="flex flex-col gap-4 px-6 py-4 animate-pulse">
      {/* Sparks history skeleton */}
      <div className="bg-white rounded-2xl p-4">
        <div className="h-6 bg-[#C7EDEF] rounded w-40 mb-4" />
        <div className="flex gap-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex-1 flex flex-col items-center gap-2">
              <div className="h-6 bg-[#C7EDEF] rounded w-10" />
              <div className="h-3 bg-[#C7EDEF] rounded w-16" />
            </div>
          ))}
        </div>
      </div>

      {/* Moods skeleton */}
      <div className="bg-white rounded-2xl p-4">
        <div className="h-6 bg-[#C7EDEF] rounded w-32 mb-4" />
        <div className="flex gap-3 justify-between">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-[#C7EDEF] rounded-2xl" />
              <div className="h-3 bg-[#C7EDEF] rounded w-10" />
            </div>
          ))}
        </div>
      </div>

      {/* Child info pill skeleton */}
      <div className="h-[75px] bg-[#C7EDEF] rounded-[48px]" />

      {/* Summary skeleton */}
      <div className="flex flex-col gap-2">
        <div className="h-5 bg-[#C7EDEF] rounded w-24" />
        <div className="h-4 bg-[#C7EDEF] rounded w-full" />
        <div className="h-4 bg-[#C7EDEF] rounded w-5/6" />
        <div className="h-4 bg-[#C7EDEF] rounded w-4/5" />
      </div>

      {/* Category cards skeleton */}
      {[1, 2].map((i) => (
        <div key={i} className="h-[120px] bg-[#C7EDEF] rounded-2xl" />
      ))}
    </div>
  );
}
